function OnsiteCommentTable($interval) {
    return {
        redirect: 'E',
        replace: true,
        scope: {
            comments: "=",
            limit: "=?"
        },
		template: require('./comment-table.html'),

        link: function (scope) {
            scope.fiveMinsAgo = new Date();
            scope.fiveMinsAgo.setMinutes(scope.fiveMinsAgo.getMinutes() - 5);

            function finalize() {
                $interval.cancel(scope.timerUpdate);
                scope.timerUpdate = null;
            }

            (function () {
                scope.timerUpdate = null;

                scope.timerUpdate = $interval(function () {
                    scope.fiveMinsAgo.setSeconds(scope.fiveMinsAgo.getSeconds() + 1);
                }, 1000);

                scope.$on('$destroy', finalize);
            })();
        }
    }
}

angular.module('onsite').directive('onsiteCommentTable', ['$interval', OnsiteCommentTable]);
